
import { useState } from "react";
import HeaderAr from "@/components/HeaderAr";
import FooterAr from "@/components/FooterAr";
import PressRelease from "@/components/PressRelease";
import NewsletterSignup from "@/components/NewsletterSignup";

const pressReleasesAr = [
  {
    id: 1,
    title: "أمة الموسيقى تطلق منصة جديدة تركز على الفنان توحد الموسيقى والتكنولوجيا",
    date: "2 يونيو 2025",
    location: "دبي، الإمارات العربية المتحدة",
    subheading: "مطابقة مدعومة بالذكاء الاصطناعي، أتاوات شفافة، وصول عالمي.",
    content: "أعلنت أمة الموسيقى اليوم عن الإطلاق العام لمنصتها الرقمية المعاد تصورها - مركز شامل حيث يلتقي المبدعون والعلامات التجارية والمعجبون تحت نماذج ترخيص وتقاسم إيرادات شفافة تماماً. مدعومة بأدوات الذكاء الاصطناعي الداخلية، يطابق النظام الجديد الفنانين مع ملخصات الأعمال في ثوانٍ بينما يضمن تقسيمات الأتاوات على البلوك تشين.",
    quotes: [
      {
        text: "بنينا أمة الموسيقى لكسر نموذج حراس البوابة القديم. الفنانون يبقون في السيطرة، العلامات التجارية تحصل على موسيقى عالمية المستوى بسرعة، والمعجبون يفوزون لأن الإبداع يدفع فعلاً.",
        author: "عامر سمحون",
        title: "المؤسس"
      },
      {
        text: "هذا التحديث يتيح لنا التوسع بمسؤولية والحفاظ على روح الموسيقى سليمة. التكنولوجيا يجب أن تضخم الفن، وليس كتمه.",
        author: "جيمس ك. بيتري",
        title: "المدير التنفيذي للعمليات"
      }
    ],
    features: [
      "<strong>المطابقة الفورية بالذكاء الاصطناعي</strong> – تطابق الملخصات مع المقاطع والجذوع في الوقت الفعلي.",
      "<strong>محرك أتاوات شفاف</strong> – مدفوعات عقود ذكية، لا تخفيضات مخفية.",
      "<strong>سوق مبدعين عالمي</strong> – 50+ دولة عند الإطلاق."
    ],
    contact: {
      email: "press@wearemusicnation.ae",
      phone: "+971-50-000-0000"
    },
    boilerplate: "حول أمة الموسيقى – مقرها في دبي، أمة الموسيقى تمزج التكنولوجيا والثقافة والإبداع لفتح مصادر إيرادات جديدة للفنانين في جميع أنحاء العالم. تعرف على المزيد في wearemusicnation.ae."
  }
];

const NewsroomHeroAr = () => {
  return (
    <section className="section-dark min-h-[70vh] relative overflow-hidden" dir="rtl">
      <HeaderAr />
      
      {/* Noise texture */}
      <div className="noise-overlay"></div>
      
      {/* Light blob effects */}
      <div className="light-blob light-blob--1"></div>
      <div className="light-blob light-blob--2"></div>
      
      <div className="editorial-container pt-32 pb-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="editorial-heading text-4xl md:text-6xl mb-6 animate-slide-in-top">
            غرفة الأخبار
          </h1>
          <p className="editorial-subheading text-xl md:text-2xl text-musicGrey max-w-3xl mx-auto animate-slide-in-top" style={{ animationDelay: '0.2s' }}>
            أحدث الإصدارات والتحديثات وما وراء الكواليس في أمة الموسيقى.
          </p>
        </div>
      </div>
    </section>
  );
};

export default function NewsroomAr() {
  const [expandedRelease, setExpandedRelease] = useState<number>(1);

  const toggleRelease = (id: number) => {
    setExpandedRelease(expandedRelease === id ? 0 : id);
  };

  return (
    <div className="min-h-screen bg-musicBlack" dir="rtl">
      <NewsroomHeroAr />
      
      <section className="section-dark py-16">
        <div className="editorial-container">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-musicWhite mb-12 text-center">
              البيانات الصحفية
            </h2>
            
            <div className="space-y-8">
              {pressReleasesAr.map((release) => (
                <PressRelease
                  key={release.id}
                  title={release.title}
                  date={release.date}
                  location={release.location}
                  subheading={release.subheading}
                  content={release.content}
                  quotes={release.quotes}
                  features={release.features}
                  contact={release.contact}
                  boilerplate={release.boilerplate}
                  isExpanded={expandedRelease === release.id}
                  onToggle={() => toggleRelease(release.id)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <NewsletterSignup />
      <FooterAr />
    </div>
  );
}
